import apiService from '../apiService';

export const addTagTypes = ['areas', 'area'] as const;

export interface Area {
  id: number;
  name: string;
  line_items: {
    id: number;
    name: string;
  }[];
}

export interface AreasResponse {
  data: Area[];
}

export const areasApi = apiService
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getAreas: build.query<any, any>({
        query: ({ search, page, per_page, pagination }) => ({
          url: `area`,
          params: { key_search: search, page, per_page, pagination },
        }),
        providesTags: ["areas"],
      }),
      getArea: build.query<any, any>({
        query: (areaId) => ({
          url: `area/show/${areaId}`,
        }),
        providesTags: ["area"],
      }),
      deleteArea: build.mutation<any, any>({
        query: (areasId) => ({
          url: `area/delete/${areasId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["areas", "area"],
      }),
      createArea: build.mutation<any, any>({
        query: (newArea) => ({
          url: `area/store`,
          method: "POST",
          body: newArea,
        }),
        invalidatesTags: ["areas"],
      }),
      updateArea: build.mutation<any, any>({
        query: (area) => ({
          url: `area/update`,
          method: "PUT",
          body: area,
        }),
        invalidatesTags: ["areas", "area"],
      }),
    }),
  });

export const {
  useGetAreasQuery,
  useGetAreaQuery,
  useDeleteAreaMutation,
  useCreateAreaMutation,
  useUpdateAreaMutation,
} = areasApi;
